import { useSearchParams } from "react-router";

const PARAM = "projects";

// The URL is the source of truth for the selected project ids, not React state: every consumer
// reads/writes the same "projects" query param via this hook, so there is nothing to keep in
// sync, the filter also survives a refresh and is shareable/bookmarkable.
export function useSelectedProjectIds(): [string[], (projectIds: string[]) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedProjectIds = searchParams.get(PARAM)?.split(",").filter(Boolean) ?? [];

  const setSelectedProjectIds = (projectIds: string[]) => {
    // `replace: true` avoids pushing a new history entry on every toggle of the filter.
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (projectIds.length === 0) {
          next.delete(PARAM);
        } else {
          next.set(PARAM, projectIds.join(","));
        }
        return next;
      },
      { replace: true }
    );
  };

  return [selectedProjectIds, setSelectedProjectIds];
}
